enum DiscountStatus {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
}

export { DiscountStatus };
